import { createFileRoute } from '@tanstack/react-router';
import { Permission, PermissionEntitiesNames } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/easm-settings/edit/$id/$organizationId/')({
  beforeLoad: ({ context, preload }) => {
    const {
      userPermissions: { hasAllowedPermissionToResource },
      validatePermissions,
    } = context;
    const isAllowed = hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.EASM_CONFIGURATION, permission: Permission.READ });
    validatePermissions({ isAllowed, preload });
  },
});
